<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="15">
					<sf-input-group label="sqlId" :inputValue="mainSqlId" :onChange="value => onChange(value)" />
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line :onClick="() => changePopupStatus('U')">{{ getMessage_('SWCC000103') }}</sf-button>
				<sf-button line :onClick="() => changePopupStatus('D')">{{ getMessage_('SWCC000140') }}</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/SQLEditor/store/helpers';
import * as yup from 'yup';
import { utils } from '@sfaas/util';

var convert = require('xml-js');

export default {
	props: {
		mainSqlId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		schema() {
			return yup.object().shape({
				sqlId: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('SWCC000881')])),
				sqlText: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('SWCC000882')])),
				serviceProgram: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('SWCC000883')]))
			});
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		...utils,
		onChange(value) {
			// this[mainSqlId] = value;
			// console.log('onChange', value);
			this.$emit('changeId', value);
		},
		changePopupStatus(status) {
			if (status === 'U') {
				this.saveSql();
			} else if (status === 'D') {
				this.deleteSql();
			}
		},
		stringConverter(str) {
			var map = {
				'&': '&amp;',
				'<': '&lt;',
				'>': '&gt;',
				'"': '&quot;',
				"'": '&#039;'
			};
			return str.replace(/[&<>"']/g, function (m) {
				return map[m];
			});
		},
		saveSql() {
			try {
				const temp = { ...this.selectedContent, serviceProgram: this.serviceProgram };
				this.schema.validateSync(temp);

				this.$sf_toggleLoading(true);

				const payload = this.stringConverter(this.selectedContent.sqlText);

				this.postUpdateSql_({
					sqlId: this.selectedContent.sqlId,
					sqlText: this.selectedContent.sqlText,
					serviceProgram: this.serviceProgram
				})
					// this.postUpdateSql_(this.selectedContent.sqlText)
					.then(header => {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		deleteTab(param) {
			//console.log('@@param', param);
			const closeIndex = this.sqlContent.findIndex(row => row.sqlId === param.sqlId);

			this.sqlContent.splice(closeIndex, 1);

			this.DEFAULT_ASSIGN({
				key: 'sqlContent',
				value: this.sqlContent
			});
		},
		deleteSql() {
			this.$sf_toggleLoading(true);
			this.postDeleteSql_(this.selectedContent)
				.then(header => {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.then(this.deleteTab(this.selectedContent))
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>
<style></style>
